import axios from 'axios'
import config from '../config'
import {JsonHeaders} from "../constants";

export default {
    getMessages(currentPage, perPage, message, user_id, archiveStatus) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            name: message,
            "user.id": user_id
        };
        if (archiveStatus !== 'all') {
            parameters['archive[exists]'] = archiveStatus;
        }
        return axios.get(config.publicPath + 'messages', {
            params: parameters,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    getMessageSelect() {
        return axios.get(config.publicPath + 'messages', {
            params: {
                'groups[]': 'select',
                'pagination': false,
                'archive[exists]': false,
                'order[name]': 'asc'
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    getMessagePreview(message, campaignId, campaignType) {
        let data = new FormData();
        data.append('id', message.id);
        data.append('name', message.name);
        data.append('subject', message.subject);
        data.append('content', message.htmlContent);
        data.append('campaignId', campaignId);
        data.append('campaignType', campaignType);

        return axios.post(config.publicPath + 'messages/preview', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        });
    },
    createMessage(formData) {
        return axios.post(config.publicPath + 'messages', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    getMessage(id) {
        return axios.get(config.publicPath + 'messages/' + id, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    },
    updateMessage(id, formData) {
        return axios.put(config.publicPath + 'messages/' + id, formData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
    archiveMessage(id) {
        return axios.post(config.publicPath + 'messages/archive/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
}
